import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VueDatePicker } from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import './assets/styles/global.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'vuestic-ui/css'
//Controles de vuestic
import {
	createVuestic,
	VaAlert,
	VaAvatar,
	VaBreadcrumbs,
	VaButton,
	VaButtonGroup,
	VaBadge,
	VaCard,
	VaCardActions,
	VaCardContent,
	VaCardTitle,
	VaCarousel,
	VaCheckbox,
	VaChip,
	VaColorInput,
	VaCounter,
	VaDateInput,
	VaDatePicker,
	VaFileUpload,
	VaIcon,
	VaImage,
	VaInnerLoading,
	VaInput,
	VaOptionList,
	VaPopover,
	VaProgressBar,
	VaProgressCircle,
	VaRadio,
	VaScrollContainer,
	VaSelect,
	VaSidebar,
	VaSidebarItem,
	VaSidebarItemContent,
	VaSidebarItemTitle,
	VaSlider,
	VaSpacer,
	VaSwitch,
	VaTab,
	VaTabs,
	VaTimeInput,
	VaTimePicker,
	VaTextarea,
	VaTreeView,
	VaSkeletonGroup,
	VaSkeleton,
	VaPagination
} from 'vuestic-ui'
import { initAuth } from './firebase/initAuth'
import VuesticTheme from '@/themes/vuesticTheme'
import * as Sentry from '@sentry/vue'
import LogRocket from 'logrocket'
import { Assets } from './types/assets'
// Inicializar la autenticación antes de montar la aplicación
initAuth().then(async () => {
	const app = createApp(App)

	// Solo inicializar Sentry si no estamos en local
	const esLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
	if (!esLocal) {
		Sentry.init({
			app,
			dsn: 'https://71b4f6c7eb9671343b33747aec10924f@o178474.ingest.us.sentry.io/4509866132766720',
			sendDefaultPii: true
		})

		LogRocket.init('ngmbew/certisep')
	} else {
		console.warn('Sentry no se inicializa en local')
	}

	// Inicializar assets
	const assets = Assets.getInstance()
	try {
		const URL_ASSETS = 'https://static-certificadostitulos.web.app/' + window.location.hostname + '/assets.json'
		const assetsMapRequest = await fetch(URL_ASSETS)
		const assetsMapData = await assetsMapRequest.json()
		assets.setAssetsMap(assetsMapData)
	} catch (error) {
		console.log('Error al inicializar assets para el host: ' + window.location.hostname, error)
	}

	app.use(store)
	app.use(router)

	// Inicializar testMode desde localStorage
	const savedTestMode = localStorage.getItem('testMode')
	if (savedTestMode !== null) {
		store.commit('setTestMode', savedTestMode === 'true')
	}

	// Registrar Vuestic con configuración del tema
	const vuesticPlugin = createVuestic({
		config: VuesticTheme.getConfig()
	})
	;(vuesticPlugin as any).install(app)

	app
		.component('va-chip', VaChip)
		.component('va-input', VaInput)
		.component('va-slider', VaSlider)
		.component('va-badge', VaBadge)
		.component('va-switch', VaSwitch)
		.component('va-select', VaSelect)
		.component('va-color-input', VaColorInput)
		.component('va-button', VaButton)
		.component('va-card', VaCard)
		.component('va-card-content', VaCardContent)
		.component('va-alert', VaAlert)
		.component('va-avatar', VaAvatar)
		.component('va-breadcrumbs', VaBreadcrumbs)
		.component('va-button-group', VaButtonGroup)
		.component('va-checkbox', VaCheckbox)
		.component('va-counter', VaCounter)
		.component('va-date-input', VaDateInput)
		.component('va-date-picker', VaDatePicker)
		.component('va-image', VaImage)
		.component('va-icon', VaIcon)
		.component('va-option-list', VaOptionList)
		.component('va-popover', VaPopover)
		.component('va-progress-bar', VaProgressBar)
		.component('va-progress-circle', VaProgressCircle)
		.component('va-radio', VaRadio)
		.component('va-scroll-container', VaScrollContainer)
		.component('va-spacer', VaSpacer)
		.component('va-tabs', VaTabs)
		.component('va-tab', VaTab)
		.component('va-time-input', VaTimeInput)
		.component('va-time-picker', VaTimePicker)
		.component('va-card-title', VaCardTitle)
		.component('va-carousel', VaCarousel)
		.component('va-sidebar-item', VaSidebarItem)
		.component('va-sidebar-item-content', VaSidebarItemContent)
		.component('va-sidebar-item-title', VaSidebarItemTitle)
		.component('va-sidebar', VaSidebar)
		.component('va-card-actions', VaCardActions)
		.component('va-file-upload', VaFileUpload)
		.component('va-inner-loading', VaInnerLoading)
		.component('va-tree-view', VaTreeView)
		.component('va-skeleton-group', VaSkeletonGroup)
		.component('va-skeleton', VaSkeleton)
		.component('va-textarea', VaTextarea)
		.component('va-pagination', VaPagination)
		.component('vue-date-picker', VueDatePicker)
		.mount('#app')
})
